<template>
    <div>
        <div class="panel animated fadeInRightBig">
            <div class="panel-heading">
                <div class="panel-title">
                    <div class="d-flex justify-content-between">
                        <b>Nova Avaria</b>
                        <b><span class="required">*</span> Campos Obrigatórios</b>
                    </div>
                    <hr/>
                </div>
            </div>
            <div class="panel-body">
                <form id="form">
                    <div class="row">
                        <div class="col-md-6 mb-3">
                            <label><span class="required">*</span> Avaria:</label>
                            <input v-model="breakdown_type.description" class="form-control">
                        </div>

                        <div class="col-md-12" style="margin-left: -35px">
                            <div class="custom-control custom-switch">
                                <div class="row">
                                    <div class="col-md-3">Gerar pendência?</div>
                                    <div class="col-md-6 ml-2">
                                        <input
                                            type="checkbox"
                                            class="custom-control-input"
                                            :id="breakdown_type.id + 'bbc'"
                                            v-model="breakdown_type.divergence"
                                        />
                                        <label
                                            class="custom-control-label"
                                            :for="breakdown_type.id + 'bbc'"
                                        ></label>
                                    </div>
                                </div>
                            </div>
                            <div class="clearfix"></div>
                        </div>
                        <div class="col-md-12" style="margin-left: -35px">
                            <div class="custom-control custom-switch">
                                <div class="row">
                                    <div class="col-md-3">Exibir no APP?</div>
                                    <div class="col-md-6 ml-2">
                                        <input
                                            type="checkbox"
                                            class="custom-control-input"
                                            :id="breakdown_type.id + 'bbcs'"
                                            v-model="breakdown_type.status"
                                        />
                                        <label
                                            class="custom-control-label"
                                            :for="breakdown_type.id + 'bbcs'"
                                        ></label>
                                    </div>
                                </div>
                            </div>
                            <div class="clearfix"></div>
                        </div>

                    </div>

                    <div class="block text-right">
                        <a class="btn btn-add" @click="save">
                            Salvar
                            <i class="fa fa-save ml-2"></i>
                        </a>
                        <router-link to="/breakdownTypes" class="btn btn-back">
                            <i class="fa fa-arrow-left mr-2"></i> Voltar
                        </router-link>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            breakdown_type: {
                description: "",
                divergence: true,
                status: true,
                required: true,
                justify: true,
            },

            errors: undefined,
        };
    },
    computed: {},
    methods: {
        save: function () {
            let url = this.$store.state.api + "breakdownTypes";
            if (this.breakdown_type.id) {
                url = this.$store.state.api + "breakdownTypes/" + this.breakdown_type.id;
                this.breakdown_type._method = 'PUT';
            }
            const self = this;

            self.$http
                .post(url, self.breakdown_type)
                .then((response) => {
                    self.$message("Sucesso", `Centro de Custo cadastrado com sucesso`, "success");
                    this.$router.push("/breakdownTypes");
                })
                .catch((error) => {
                    self.errors = error.response.data;

                    if (typeof self.errors === "object") {
                        let html = "<ul>";

                        $.each(self.errors, function (key, value) {
                            html += "<li>" + value[0] + "</li>";
                        });

                        html += "</ul>";

                        self.errors = html;
                    }

                    self.$message(null, self.errors, "error");
                });
        },

        getData(id) {
            const api = this.$store.state.api + "breakdownTypes/" + id;
            const self = this;

            self.$http
                .get(api)
                .then((response) => {
                    self.breakdown_type = response.data.data[0];
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    },
    mounted: function () {
        const id = this.$route.params.id;
        if (id) {
            this.getData(id);
        }
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/BreakdownTypes/Add.vue